import React from 'react'
import { useLocation } from 'react-router-dom'
import CarouselServices, {servicesTravel} from '../../share/components/CarouselServices/CarouselSevices'
import Banner from './Banner/Banner'
import InfoDetailClinic from './infoClinic/InfoDetailClinic'

const Detailsclinics = () => {

  const {
    state
  } = useLocation()


  return (
    <div>
        <CarouselServices current={servicesTravel[8].title}/>
        <Banner name={state.name} address={state.address} urlImg={state.urlImg} pathImage={state.pathImage}/>
        <InfoDetailClinic address={state.address} city={state.city} description={state.description} img={state.pathImage} name={state.name} stars={state.stars} subCategories={state.subCategories} />
    </div>
  )
}

export default Detailsclinics